import PropTypes from 'prop-types';

import './PercentTable.scss';

import PercentTableItem from './percent-table-item/PercentTableItem';

const PercentTable = ({ data, focused, onHover, onMouseClick, onMouseLeave }) => {
    if (!data) {
        return null;
    }

    let itemList = data.map((dataItem, index) =>
        <PercentTableItem key={index} name={dataItem.label} count={dataItem.value + '%'} color={dataItem.color} onHover={onHover} onMouseClick={onMouseClick} onMouseLeave={onMouseLeave} focused={focused}/>
    );

    return <div className="percentTableWrapper">
        <ul>
            {itemList}
        </ul>
    </div>;
};

PercentTable.defaultProps = {
    onHover: () => {},
    onMouseLeave: () => {},
    onMouseClick: () => {}
};

PercentTable.propTypes = {
    data: PropTypes.array.isRequired,
    focused: PropTypes.string,
    onHover: PropTypes.func,
    onMouseClick: PropTypes.func,
    onMouseLeave: PropTypes.func
};

export default PercentTable;
